import script from "./MoleculeTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTable.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeTable.vue?vue&type=style&index=0&id=3d1f75df&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d1f75df"]])

export default __exports__